export default __webpack_public_path__ + "assets/resizedQuebec-min.00b9c91e.webp";